export const BG_GRADIANT = 'linear-gradient(180deg, #CDEEF4 0%, #BCD6F0 100%)'
export const FROM_OTHER_REPLY_BG = '#D5D5FB'
export const FROM_ME_REPLY_BG = '#080f1126'
export const FROM_ME_SURFER_BG = '#080D1135'
export const MESSAGE_BG_BOX_SHADOW = '0px 0px 4px 0px rgba(0, 0, 0, 0.10)'
export const HIDE_SCROLLBAR_CLASS = '--hide-scrollbar'
export const DISABLE_SELECTION_CLASS = '--no-select'
export const FULLSCREEN_ELEMENT_CLASS = '--fullscreen-mode'

export const CUSTOM_SCROLL_CLASS = 'scroller'
